import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined';
import Grid from "@material-ui/core/Grid/Grid";
import MakeRequest from "./../Make/MakeRequest";
import FormControlLabel from "@material-ui/core/es/FormControlLabel/FormControlLabel";
import Checkbox from "@material-ui/core/es/Checkbox/Checkbox";
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox'
import HighlightOffOutlinedIcon from '@material-ui/icons/HighlightOffOutlined';
import Alert from "@material-ui/lab/Alert/Alert";
import clsx from "clsx";

const useStyles = makeStyles({
    root: {
        padding: '10px 10px 0 10px',
        width: '100%'
    },
    chips: {
        width: '100%',
        margin: '0 5px',
        marginBottom: -1
    },
    btn: {
        borderRadius: 2,
        border: '1px solid #3f51b4',
        color: '#3f51b4',
        padding: '3px 10px',
        cursor: 'pointer',
        fontSize: '0.8rem',
        display: 'inline-block',
    },
    btnActive: {
        borderRadius: 2,
        backgroundColor: '#3f51b4',
        color: '#fff',
    },

    block: {
        wborder: '1px dashed #3f51b4',
        wpadding: 15,
        wwidth: '100%',
        margin: '0 15px',
    },
    expand: {
        marginRight: 5,
        cursor: 'pointer'
    },
    makes: {
        marginBottom: 20,
        borderBottom: '1px dashed #ccc'
    },
    makesCont: {
        maxHeight: 300,
        overflowY: 'scroll'
    },
    option: {
        width: '100%',
    },
    checkbox: {
        margin: 0,
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 20

    },
    makeLabel: {
        width: 55,
    },
    makeMobile: {
        maxWidth: 160
    },
    make: {
        maxWidth: 130
    },
    modelMakesLabel: {
        marginLeft: 10
    }
});

export default function ModelMobile(props) {

    const [open, setOpen] = React.useState();

    const [make, setMake] = React.useState();

    const [error, setError] = React.useState();

    const [counter, setCounter] = React.useState(0);

    const classes = useStyles();

    const params = props.filter.params;

    const filter = props.filter;

    const handleOpenClick = () => {
        setOpen(!open);
    };

    const handleData = (data) => {
        setMake(data);
    };

    const handleError = (error) => {
        setError(error);
    };

    const arrMakes = [];
    const arrModels = [];
    for (let i in params.selectedMakes) {
        arrMakes.push(i);
        if (params.selectedMakes[i]['models']) {
            for (let j in params.selectedMakes[i]['models']) {
                arrModels.push(j);
            }
        }
    }

    const handleChange = (make, model, checked) => {
        if (checked) {
            if (!params.selectedMakes[make]['models']) {
                params.selectedMakes[make]['models'] = {};
            }
            params.selectedMakes[make]['models'][model] = {};
        } else {
            delete params.selectedMakes[make]['models'][model];
        }
        filter.dispatchFilter();
        render();
    };

    const handleConfirm = e => {
        e.preventDefault();
        setOpen(false);
    };

    const handleClearClick = () => {
        for (let i in params.selectedMakes) {
            delete params.selectedMakes[i]['models'];
        }
        filter.dispatchFilter();
        render();
    };

    const render = () => {
        setCounter(counter + 1);
    };

    const makesByMake = {};

    if (arrMakes.length && make) {
        make.map(item => {
            makesByMake[item.label] = item;
        })
    }

    if (!arrMakes.length) {
        return null;
    }

    console.log('makesByMake', makesByMake);

    return (
        <div className={classes.block}>
            <Typography>
                <Grid container className={props.classes.grid}>
                    <Grid item onClick={handleOpenClick}>
                        {open ?
                            <IndeterminateCheckBoxIcon color="primary" className={classes.expand}/>
                            : <AddBoxOutlinedIcon color="primary" className={classes.expand}/>}
                    </Grid>
                    <Grid item className={classes.makeLabel}>Model: </Grid>
                    <Grid item onClick={handleOpenClick} className={
                        clsx(props.isMobile ? classes.makeMobile : classes.make, props.classes.cutText)}>
                        <a href="#" className={props.classes.value} onClick={(e) => e.preventDefault()}>
                                {arrModels.length ? arrModels.join(', ') : 'All'}
                            </a>
                    </Grid>
                    {!open && arrMakes.length ? <div className={props.classes.done} onClick={handleClearClick}>
                        <HighlightOffOutlinedIcon className={props.classes.clear}/>
                    </div> : null}
                    {open ? <div className={props.classes.done}><a href="#" className={props.classes.ok} onClick={handleConfirm}>OK</a></div> : null}
                </Grid>
            </Typography>
            {open ?
            <div className={classes.makes}><div className={classes.makesCont}>
                {error ? <Alert severity="error">{error}</Alert> : null }
                {!make && !error ? <MakeRequest onData={handleData} onError={handleError}/> : null}
                {make ? arrMakes.map(m => {
                    return <div className={classes.option}>
                        {arrMakes.length > 1 ? <Typography className={classes.modelMakesLabel}
                        ><b>{m} models</b></Typography> : null}
                        {makesByMake[m].model.map(model => {
                            return <div className={clsx(classes.option, props.classes.cutText)}>
                                <FormControlLabel
                                control={
                                    <Checkbox
                                        className={classes.checkbox}
                                        checked={!!(params.selectedMakes[m] && params.selectedMakes[m]['models']
                                            && params.selectedMakes[m]['models'][model.label])}
                                        onChange={(e) => handleChange(m, model.label, e.target.checked)}
                                        name={model.label}
                                        color="primary"
                                    />
                                }
                                label={model.label}
                            /></div>
                        })}
                        </div>
                }) : null}
                {!make && !error ? <CircularProgress size="small"/> : null}
            </div></div> : null}
        </div>
    )
}